import React, { useState } from "react";
import { Box, Typography, alpha } from "@mui/material";
import InfoPopUp from "../../Common/InfoPopUp";
import InfoIcon from "@mui/icons-material/Info";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import { useSelector } from "react-redux";

const IDTier2 = () => {
  const { btncolor } = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  return (
    <>
      <Box
        sx={{
          px: { xs: 2, md: 4 },
          py: { xs: 2, md: 3 },
          backgroundColor: "var(--body-color)",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        {/* Hero Banner */}
        <Box
          sx={{
            borderRadius: "18px",
            px: { xs: 3, md: 4 },
            py: { xs: 3, md: 3.5 },
            mb: 3,
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
            background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, position: "relative", zIndex: 1 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255,255,255,0.18)",
                border: "1px solid rgba(255,255,255,0.25)",
                backdropFilter: "blur(6px)",
                flexShrink: 0,
              }}
            >
              <VerifiedUserOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{
                    fontSize: { xs: "1.3rem", md: "1.6rem" },
                    fontWeight: 700,
                    color: "#fff",
                    lineHeight: 1.15,
                    letterSpacing: "-0.015em",
                  }}
                >
                  Identity Verification (Tier 2)
                </Typography>
                <InfoIcon
                  sx={{ color: "rgba(255,255,255,0.65)", fontSize: 18, cursor: "pointer", flexShrink: 0 }}
                  onClick={() => setShow(true)}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.75 }}>
                <HourglassTopOutlinedIcon sx={{ color: "#fcd34d", fontSize: 16 }} />
                <Typography
                  sx={{
                    fontSize: { xs: "0.82rem", md: "0.88rem" },
                    color: "#fcd34d",
                    fontWeight: 600,
                  }}
                >
                  Tier 2 Identity verification documents submitted.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Status Card */}
        <Box
          sx={{
            backgroundColor: "var(--body-color-less)",
            borderRadius: "16px",
            border: "1px solid rgba(125,125,125,0.15)",
            boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
            p: { xs: 3, md: 4 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              p: 2.5,
              borderRadius: "12px",
              backgroundColor: "rgba(251,191,36,0.06)",
              border: "1px solid rgba(251,191,36,0.2)",
            }}
          >
            <HourglassTopOutlinedIcon sx={{ color: "#f59e0b", fontSize: 22, flexShrink: 0, mt: "2px" }} />
            <Box>
              <Typography
                sx={{
                  fontSize: "0.92rem",
                  fontWeight: 600,
                  color: "var(--text-color)",
                  mb: 0.5,
                }}
              >
                Documents Under Review
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.84rem",
                  color: "var(--text-color)",
                  opacity: 0.65,
                  lineHeight: 1.6,
                }}
              >
                Your identity documents are currently in review. This process may take up to 48 hours. Please check your email for updates regarding the status.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={"Identity Verification Tier 2"}
        description={`Submit ID proof Address proof and Profile photo for tier 2 verification. After submitting Tier 2 documents another section will open for Tier 3`}
      />
    </>
  );
};

export default IDTier2;
